import React, { Component } from "react"
import ParkingProductHighlightElement from "./parkingProductHighlightElement"
import Spinner from "../spinner"
import { getContentEnrichedProduct } from "../../helpers/bookingHelper"
import config from "react-global-configuration"
import ParkingProductHighlightElementNew from "./parkingProductHighlightElementNew"
import Slider from "react-slick"

class ParkingProductHightlight extends Component {
  static defaultProps = {
    highlights: undefined,
    content: {},
  }

  constructor(props) {
    super(props)

    this.state = {}
  }

  componentDidMount() {
    window.addEventListener("resize", () => {
      this.setState({ screenWidth: window.innerWidth })
    })
  }

  getProductData(highlights) {
    const { content } = this.props
    if (highlights && Object.keys(highlights).length > 0) {
      let highlightsAsArray = Object.keys(highlights).map((prop) => {
        if (highlights && highlights[prop]) return highlights[prop]?.products[0]
      })
      let contentEnrichedProducts = highlightsAsArray.map((resultProduct) => resultProduct && getContentEnrichedProduct(resultProduct, content))
      return contentEnrichedProducts
    }
    return []
  }

  handleSpecialProductClick = (highlightProduct) => {
    this.props.setParkingDetailModalState({
      parkingDetailsModalGaList: this.props.gaList,
      parkingDetailsModalGaListIndex: this.props.gaListIndex,
      isParkingSpecialProductActive: true,
      parkingDetailsModalItem: getContentEnrichedProduct(highlightProduct, this.props.content),
    })
  }

  handleMemberProductClick = (highlightProduct) => {
    this.props.setParkingDetailModalState({
      parkingDetailsModalGaList: this.props.gaList,
      parkingDetailsModalGaListIndex: this.props.gaListIndex,
      isParkingMemberProductActive: true,
      parkingDetailsModalItem: getContentEnrichedProduct(highlightProduct, this.props.content),
    })
  }

  handleBuyClickFunction = (item) => {
    const { product, result } = item

    const isSpecialProduct = product && product.dynamicFields && product.dynamicFields.isSpecialProduct
    const showMemberprice = result?.showMemberPrice

    const { userAccountDetails } = this.props

    const isLoggedIn = !!userAccountDetails

    isSpecialProduct
      ? this.handleSpecialProductClick(item)
      : showMemberprice && !isLoggedIn
        ? this.handleMemberProductClick(item)
        : this.props.handleReservation(product.id, item)
  }

  checkForPromoBanner = (hightlightProducts) => {
    const { globals } = this.props
    let hasPromoLabel = false
    hightlightProducts.every((highlightProduct) => {
      if (!highlightProduct) {
        return
      }
      const { result, product } = highlightProduct
      let promotionBanner =
        result.originalPrice > result.totalPrice && globals.promotionName
          ? globals.promotionName
          : result && result.thirdPartyPromoLabelText
            ? result.thirdPartyPromoLabelText
            : product.dynamicFields && product.dynamicFields.calloutBanner
              ? product.dynamicFields.calloutBanner
              : undefined

      const affiliateCheck = this.props.affiliateCode && result.affiliateResult && product.dynamicFields.affiliateBanner
      if (affiliateCheck) {
        promotionBanner = product.dynamicFields.affiliateBanner
      }

      if (promotionBanner) {
        hasPromoLabel = true
        return false
      }
      return true
    })
    return hasPromoLabel
  }

  getHighlightElements = (hightlightProducts) => {
    if (!hightlightProducts || hightlightProducts.length === 0) return null

    const { userAccountDetails, globals, useNewDesign, uspLimit } = this.props
    const isLoggedIn = !!userAccountDetails
    const parkingListListElementTextKeys = config.get("textKeys.parkingList.listElement") || {}
    const typeTexts = config.get("textKeys.productHighlights.typeText")

    const highlights = hightlightProducts.map((highlightProduct, index) => {
      if (!highlightProduct) return null

      const { result, product } = highlightProduct
      let promotionBanner =
        result.originalPrice > result.totalPrice && globals.promotionName
          ? globals.promotionName
          : result && result.thirdPartyPromoLabelText
            ? result.thirdPartyPromoLabelText
            : product.dynamicFields && product.dynamicFields.calloutBanner
              ? product.dynamicFields.calloutBanner
              : undefined

      // use affiliateBanner if an affiliateCode is active
      const affiliateCheck = this.props.affiliateCode && result.affiliateResult && product.dynamicFields.affiliateBanner
      if (affiliateCheck) {
        promotionBanner = product.dynamicFields.affiliateBanner
      }

      // threshold defined by CPH
      highlightProduct.urgency = Math.abs(product.maxCapacity - product.currentlyBooked) <= 25 && !product.isSoldOut

      let limit = 1
      let usp = {}
      let typeText = ""

      const buttonOnClickFunction = () => this.handleBuyClickFunction(highlightProduct)

      // left
      if (index === 0) {
        //2 //
        limit = 2
        typeText = typeTexts?.productHighlightStep1TypeText || "Billigeste parkering"
      }
      // right
      if (index === 2) {
        // 3
        limit = 3
        typeText = typeTexts?.productHighlightStep3TypeText || "Bedst til prisen"
      }
      // center
      if (index === 1) {
        // 6
        limit = 6
        typeText = typeTexts?.productHighlightStep2TypeText || "Lige ved terminalerne"
      }

      var carParkContent = this.props.content.carParks[highlightProduct?.location]

      if (useNewDesign) {
        if (carParkContent && carParkContent.usp && carParkContent.usp.bullets) {
          limit = uspLimit
          usp.headline = carParkContent.usp.headline
          usp.bullets = carParkContent.usp.bullets.slice(0, limit)
        }
      } else {
        if (highlightProduct && highlightProduct.usp && highlightProduct.usp.bullets) {
          usp.headline = highlightProduct.usp.headline
          usp.bullets = highlightProduct.usp.bullets.slice(0, limit)
        }
      }

      if (useNewDesign) {
        return (
          <ParkingProductHighlightElementNew
            key={index}
            {...highlightProduct}
            arrivalDate={this.props.arrivalDate}
            arrivalTime={this.props.arrivalTime}
            departureDate={this.props.departureDate}
            departureTime={this.props.departureTime}
            cookies={this.props.cookies}
            typeText={typeText}
            usp={usp}
            ribbonText={promotionBanner}
            modalButtonOnClick={() =>
              this.props.setParkingDetailModalState({
                parkingDetailsModalGaList: this.props.gaList,
                parkingDetailsModalGaListIndex: this.props.gaListIndex,
                isParkingDetailsModalActive: true,
                isParkingHighlightModalActive: true,
                parkingDetailsModalItem: highlightProduct,
              })
            }
            buttonOnClick={highlightProduct.product.isSoldOut ? undefined : buttonOnClickFunction.bind(this)}
            priceFormatter={this.props.priceFormatter}
            buttonClass={highlightProduct.product.isSoldOut ? "is-disabled" : ""}
            buttonText={
              highlightProduct.product.isSoldOut
                ? parkingListListElementTextKeys.soldOut || "Udsolgt"
                : parkingListListElementTextKeys.reserve || "Reservér"
            }
            isLoggedIn={isLoggedIn}
            flightId={this.props.flightId}
            handleCloseMapModal={this.props.handleCloseMapModal}
            handleOpenMapModal={this.props.handleOpenMapModal}
            mapOnClick={() =>
              this.props.setParkingDetailModalState({
                parkingDetailsModalItem: highlightProduct,
              })
            }
            spacer={!!promotionBanner && !this.props.enableCarousel ? "spacer" : ""}
            affiliateCode={this.props.affiliateCode}
            globals={this.props.globals}
          />
        )
      }

      return (
        <ParkingProductHighlightElement
          key={index}
          {...highlightProduct}
          arrivalDate={this.props.arrivalDate}
          arrivalTime={this.props.arrivalTime}
          departureDate={this.props.departureDate}
          departureTime={this.props.departureTime}
          cookies={this.props.cookies}
          typeText={typeText}
          usp={usp}
          ribbonText={promotionBanner}
          modalButtonOnClick={() =>
            this.props.setParkingDetailModalState({
              parkingDetailsModalGaList: this.props.gaList,
              parkingDetailsModalGaListIndex: this.props.gaListIndex,
              isParkingDetailsModalActive: true,
              isParkingHighlightModalActive: true,
              parkingDetailsModalItem: highlightProduct,
            })
          }
          buttonOnClick={highlightProduct.product.isSoldOut ? undefined : buttonOnClickFunction.bind(this)}
          priceFormatter={this.props.priceFormatter}
          buttonClass={highlightProduct.product.isSoldOut ? "is-disabled" : ""}
          buttonText={
            highlightProduct.product.isSoldOut
              ? parkingListListElementTextKeys.soldOut || "Udsolgt"
              : parkingListListElementTextKeys.reserve || "Reservér"
          }
          isLoggedIn={isLoggedIn}
          flightId={this.props.flightId}
          affiliateCode={this.props.affiliateCode}
          globals={this.props.globals}
        />
      )
    })

    return highlights
  }

  render() {
    const { deck, wrapper, useNewDesign, enableCarousel } = this.props
    const hightlightProducts = this.getProductData(this.props.highlights)
    const hasPromoLabel = this.checkForPromoBanner(hightlightProducts)
    const hightlightElements = this.getHighlightElements(hightlightProducts)

    const innerWidth = window.innerWidth
    var settings = {
      dots: false,
      arrows: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipe: true,
      variableWidth: true,
    }

    const style = { "--slick-element-width": `${innerWidth * 0.65}px` }

    if (useNewDesign && enableCarousel && innerWidth <= 567) {
      return (
        <section className={`${deck} ${hasPromoLabel ? "deck--parking-podium" : ""}`}>
          <Spinner isActive={this.props.ajaxSpinnerActive} isTransparent={this.props.ajaxSpinnerTransparent} />
          <div className="podium-slider" style={style}>
            <Slider {...settings}>{hightlightElements}</Slider>
          </div>
        </section>
      )
    }

    return (
      <section className={`${deck} ${innerWidth >= 768 ? "deck--padding-bottom" : ""} ${hasPromoLabel ? "deck--parking-podium" : ""}`}>
        <div className={wrapper}>
          <Spinner isActive={this.props.ajaxSpinnerActive} isTransparent={this.props.ajaxSpinnerTransparent} />
          <div className="grid">{hightlightElements}</div>
        </div>
      </section>
    )
  }
}
export default ParkingProductHightlight
